module.exports = __webpack_public_path__ + "img/jine.3e05ecaf.png";